export const category = "/category"
export const tag = "/tag"
export const products = "/products"
export const catalog = "/catalog"
export const slide_images = "/image-slide"
export const quotation = "/quotation"
export const pin_products = "/products_pinned"
export const highlight_products = "/products_highlight"
